import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, FileMeta } from '/imports/types';
import { Accounts, Roles } from '/imports/api/accounts';

export interface Notification extends Doc {
  _id: string;
  title: string;
  body: string;
  image?: FileMeta;
  icon?: string;
  link?: string;
  meta?: any;
  accountId?: string;
  userId?: string;
  isRead?: boolean;
}
export type Model = Notification;

export const Notifications = new Mongo.Collection<Notification>('notifications');

export const markNotificationsRead = DeclareMethod<void, void>('markNotificationsRead');

Meteor.isServer && Meteor.startup(async () => {
  await Notifications.createIndexAsync({ userId: 1 }, { sparse: true });
  await Notifications.createIndexAsync({ accountId: 1 }, { sparse: true });
});

export const notify = async (notification: Omit<Notification, '_id'>) => {
  await Notifications.insertAsync({ createdAt: new Date(), ...notification });
};

/**
 * Fan out a notification to every admin/dispatcher account in the given org.
 * Each recipient gets their own Notification record so read-state is per-user.
 */
export const notifyOrg = async (
  orgId: string,
  notification: Omit<Notification, '_id' | 'accountId' | 'userId'>,
) => {
  if (!orgId) return;
  const accounts = await Accounts.find({
    orgId,
    active: { $ne: false },
    roles: { $in: [Roles.admin, Roles.dispatcher] },
  }).fetchAsync();
  const createdAt = new Date();
  for (const a of accounts) {
    await Notifications.insertAsync({
      createdAt,
      ...notification,
      accountId: a._id,
      userId: a.userId,
    } as Notification);
  }
};